
import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { AIAgent } from '@/hooks/useCareerChat';

interface ChatHeaderProps {
  title: string;
  shouldAutoSpeak: boolean;
  toggleAutoSpeak: () => void;
  isAuthenticated: boolean;
  agent?: AIAgent | null;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ 
  title, 
  shouldAutoSpeak, 
  toggleAutoSpeak, 
  isAuthenticated,
  agent
}) => {
  return (
    <div className="flex items-center justify-between p-3 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center gap-2">
        <Avatar className="w-8 h-8">
          <AvatarImage src={agent?.photo_url || ""} alt={title} />
          <AvatarFallback>{title.charAt(0)}</AvatarFallback>
        </Avatar>
        <div>
          <h3 className="font-medium text-sm">{title}</h3>
          {agent?.expertise && (
            <p className="text-xs text-muted-foreground">{agent.expertise}</p>
          )}
        </div>
      </div>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button 
              onClick={toggleAutoSpeak}
              className={`p-2 rounded-full transition-colors ${shouldAutoSpeak ? 'text-primary hover:bg-primary/10' : 'text-muted-foreground hover:bg-muted'} ${!isAuthenticated ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={!isAuthenticated}
              aria-label={shouldAutoSpeak ? "Disable voice responses" : "Enable voice responses"}
            >
              {shouldAutoSpeak ? <Volume2 size={18} /> : <VolumeX size={18} />}
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            {isAuthenticated 
              ? (shouldAutoSpeak ? "Disable voice responses" : "Enable voice responses") 
              : "Sign in to enable voice features"}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ChatHeader;
